<template>
  <div class="indexReport">
    <header>
      <el-card shadow="never" style="padding-top:20px;">
        <el-form inline class="rd-s">
          <el-form-item label="公众号:" style="margin-right:24px">
            <el-select
              v-model="selectQueryData.app_id"
              placeholder="全部"
              clearable
              filterable
              @clear="doClearAction('app')"
            >
              <el-option
                v-for="(item,indexr) in selectListData.data
                  ? selectListData.data.account
                  : null"
                :key="indexr"
                :label="item.account_name"
                :value="item.app_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="平台:" style="margin-right:24px">
            <el-select
              v-model="selectQueryData.platform_id"
              placeholder="全部"
              clearable
              filterable
              @clear="doClearAction('platform')"
            >
              <el-option
                v-for="item in selectListData.data
                  ? selectListData.data.platform
                  : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="书名:" style="margin-right:24px">
            <!-- <el-select
              v-model="selectQueryData.novel_id"
              placeholder="全部"
              clearable
              filterable
              @clear="doClearAction('novel')"
            >
              <el-option
                v-for="item in selectListData.data
                  ? selectListData.data.novel
                  : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select> -->
            <el-autocomplete
              v-model="novel_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入小说名称"
              @select="handleSelect"
            />
          </el-form-item>
          <el-form-item v-if="displayType === 'list'" label="主角:" style="margin-right:24px">
            <el-select
              v-model="selectQueryData.lead_id"
              placeholder="全部"
              clearable
              filterable
              @clear="doClearAction('lead')"
            >
              <el-option
                v-for="item in selectListData.data
                  ? selectListData.data.lead
                  : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="投放者:" style="margin-right:24px">
            <el-select
              v-model="selectQueryData.user_id"
              placeholder="全部"
              filterable
              clearable
              @clear="doClearAction('user')"
            >
              <el-option
                v-for="item in selectListData.data
                  ? selectListData.data.user
                  : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="年份">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item label="投放版位">
          <el-select placeholder="全部投放版位" />
        </el-form-item> -->
          <br>
          <el-form-item label="时间:">
            <el-date-picker
              v-model="timesr"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :default-value="timeDefaultShow"
              @change="getData"
            />
          </el-form-item>
          <el-form-item v-if="displayType === 'chart'" label="投放平台" style="margin-left:24px">
            <el-select v-model="selectQueryData.launch_platform_type" placeholder="请选择">
              <el-option
                v-for="item in optionstoufang"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <div class="btn-setbox">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="btn-po"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              type="default"
              icon="el-icon-refresh"
              class="btn-po"
              @click="handleReset"
            >重置</el-button>
            <el-button
              v-if="displayType === 'list'"
              type="primary"
              icon="el-icon-download"
              class="btn-po"
              @click="handleDownloadData"
            >导出报表</el-button>
            <el-button
              v-if="displayType === 'chart'"
              type="primary"
              icon="el-icon-download"
              class="btn-po"
              @click="newhandleDownloadData"
            >导出报表</el-button>
          </div>
        </el-form>
        <!-- <el-form>
          <el-form-item label="时间:">
            <el-date-picker
              v-model="timesr"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :default-value="timeDefaultShow"
              @change="getData"
            />
          </el-form-item>
        </el-form> -->
        <!-- <div class="btn-setbox">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="btn-po"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            type="default"
            icon="el-icon-refresh"
            class="btn-po"
            @click="handleReset"
          >重置</el-button>
        </div> -->
      </el-card>
    </header>
    <el-card v-if="displayType === 'list'" shadow="never">
      <div class="title">
        <div style="padding:24px 0">
          <div style="margin-right: 20px">
            上次更新时间为：{{
              updateTime === null ? '0000-00-00 00:00:00' : updateTime
            }}
          </div>
          <div>
            <label>书城账号密码</label>
            <label>更新数据</label>
            <label>更新月表数据</label>
          </div>
        </div>
        <div>
          <!-- <el-button
            type="primary"
            icon="el-icon-download"
            class="btn-po"
            @click="handleDownloadData"
          >导出报表</el-button> -->
        </div>
      </div>
      <!-- 列表视图 -->
      <main v-if="displayType === 'list'">
        <div class="form">
          <div class="form-top">
            <div class="title">
              <span>关键指标明细</span>
              <span style="margin-left: 10px">(</span>
              <span
                class="aggregateData"
                style="margin-left: 0px"
              >总成本：<span class="blue">{{
                data ? data.account_recharge : 0
              }}</span>
                <span class="aggregateData">总充值：</span><span class="blue">{{ data ? data.order_money : 0 }}</span>
                <span class="aggregateData">总回收率：</span><span class="blue">{{ data ? data.tcba : 0 }}%</span>
                <!--          <strong class="aggregateData">总腾讯消耗：<span>{{}}</span></strong>-->
                <span class="aggregateData">增长率：</span><span class="blue">{{ data ? data.ir : 0 }}%</span> )</span>
              <div style="position: relative">
                <span style="margin-left: 10px">首付金额</span>
                <el-switch
                  v-model="value"
                  :width="40"
                  active-color="#409EFF"
                  inactive-color="rgb(191,191,191)"
                  style="margin-left: 10px"
                />
              </div>
            </div>
            <div class="table-label">
              <span>
                <img src="../../assets/images/13.小说/Wallet.webp">充值</span>
              <span>
                <img src="../../assets/images/13.小说/Financing.webp">单价</span>
              <span>
                <img src="../../assets/images/13.小说/Optional.webp">当日充值回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Trend.webp">累计充值回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card.webp">首冲回本</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card-two.webp">复充回本</span>
              <span>
                <img src="../../assets/images/13.小说/Group847.webp">首冲金额</span>
              <span>
                <img src="../../assets/images/13.小说/Currency.webp">复充金额
              </span>
            </div>
          </div>
        </div>
        <!-- 备份 -->
        <div class="table">
          <el-table
            v-loading="loading"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :header-cell-style="headerCellStyle"
            style="width: 100%"
          >

            <el-table-column
              fixed
              prop="date"
              align="center"
              :width="103"
            >
              <template slot="header">
                <div class="a-c">
                  <label>日期</label>
                  <i
                    slot="reference"
                    class="el-icon-s-comment rechargeButton"
                    @click="handleShowRechargeData"
                  />
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.date }}
              </template>
            </el-table-column>
            <el-table-column
              prop="order_money"
              label="累计充值"
              align="center"
              sortable
              :width="103"
            />
            <template v-if="showRechargeDataFlag">
              <el-table-column
                v-for="(item, idx) in tableData[0].specially_day_data || []"
                :key="idx"
                prop="order_money"
                :label="'充值' + '-' + rechargeDay[idx] + '天'"
                align="center"
                sortable
                :width="150"
              >
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.specially_day_data[idx].zc }}
                  </span>
                  <br>
                  <span>
                    {{ scope.row.specially_day_data[idx].tcbi }}
                  </span>
                </template>
              </el-table-column>
            </template>
            <el-table-column
              :key="itemKey"
              prop="account_recharge"
              label="成本"
              align="center"
              sortable
              :width="130"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.show">
                  <input
                    v-model="cost"
                    v-focus
                    class="costInput"
                    autofocus="autofocus"
                    :placeholder="scope.row.account_recharge"
                    @keydown.enter="handlCostKeyDown"
                    @blur="handlCostKeyDown"
                  >
                </span>
                <span
                  v-if="!scope.row.show"
                  @dblclick="reSetCost(scope.row)"
                >
                  {{ scope.row.account_recharge }}
                </span>
                <i
                  class="el-icon-edit editIcon"
                  @click="reSetCost(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="tcba"
              label="回本率"
              align="center"
              :width="108"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.tcba }}%</div>
                <div>距今{{ scope.row.diff_today }}天</div>
              </template>
            </el-table-column>
            <!-- <el-table-column
            prop="ir"
            label="增长率"
            align="right"
            :width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.ir }}%
            </template>
          </el-table-column> -->
            <el-table-column
              prop="profit"
              label="利润"
              align="center"
              :width="103"
            />
            <el-table-column
              v-for="(title, indx) in tableData.length > 0
                ? tableData[0].data
                : []"
              :key="indx + 8888"
              align="center"
              :label="'第' + (indx + 1) + '天'"
              :width="220"
            >
              <template slot-scope="scope">
                <div style="color: #f53f3f">
                  <img
                    src="../../assets/images/13.小说/Wallet.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  {{ scope.row.data[indx].zc }}
                </div>
                <div class="powder">
                  <img
                    src="../../assets/images/13.小说/Optional.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  {{ scope.row.data[indx].tcb }}
                  <el-divider direction="vertical" />
                  <img
                    src="../../assets/images/13.小说/Trend.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span>{{ scope.row.data[indx].tcbi }}</span>
                </div>
                <div class="powder">
                  <img
                    src="../../assets/images/13.小说/Bank-card.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="green">{{ scope.row.data[indx].scb }}</span>
                  <el-divider direction="vertical" />
                  <img
                    src="../../assets/images/13.小说/Bank-card-two.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="yellow">{{ scope.row.data[indx].fcb }}</span>
                  <!-- <span class="blue">{{ scope.row.data[indx].cao }}</span> -->
                </div>
                <div class="powder">
                  <img
                    src="../../assets/images/13.小说/Financing.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="blue">{{ scope.row.data[indx].cao }}</span>
                </div>
                <div v-show="value">
                  <img
                    src="../../assets/images/13.小说/Currency.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="green">{{ scope.row.data[indx].sc }}</span>
                  <el-divider direction="vertical" />
                  <img
                    src="../../assets/images/13.小说/Currency.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="yellow">{{ scope.row.data[indx].fc }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <pagination :total="total" :page.sync="pageData.page" :limit.sync="pageData.page_size" @pagination="getList" /> -->
        <pagination-right
          ref="pagination"
          :total="total"
          :page-sizes="[10]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </main>
    </el-card>

    <!-- 图表视图 -->
    <main v-if="displayType === 'chart'" style="background:none;">
      <el-card
        shadow="never"
      >
        <div style="display: flex;align-items: center;justify-content: space-between;padding: 24px 0px ">
          <!-- 1. 总成本 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chengben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总成本</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="newobj ? newobj.account_recharge : 0"
                  :start-val="0"
                  :end-val="newobj ? Number(newobj.account_recharge) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 2. 总充值 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chongzhi.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总充值</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="newobj ? newobj.order_money : 0"
                  :start-val="0"
                  :end-val="newobj ? Number(newobj.order_money) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 3. 总回本率 (百分比，保留2位小数) -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/huiben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总回本率</div>
              <div>
                <count-to
                  :key="newobj ? newobj.tcbi : 0"
                  :start-val="0"
                  :end-val="newobj ? Number(newobj.tcbi) : 0"
                  :duration="1500"
                  :decimals="2"
                />
                <span>%</span>
              </div>
            </div>
          </div>

          <!-- 4. 增长率 (百分比，保留2位小数) -->
          <!-- <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/zengzhang.png"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>增长率</div>
              <div>
                <count-to
                  :key="data ? data.ir : 0"
                  :start-val="0"
                  :end-val="data ? Number(data.ir) : 0"
                  :duration="1500"
                  :decimals="2"
                />
                <span>%</span>
              </div>
            </div>
          </div> -->
        </div>
      </el-card>
      <el-card style="padding: 16px;margin:16px 0px;" shadow="never">
        <div class="form" style="border:none;padding-top:0;">
          <div class="form-top">
            <div class="title">
              <span>关键指标明细</span>
              <span style="margin-left: 10px">(</span>
              <span
                class="aggregateData"
                style="margin-left: 0px"
              >总成本：<span class="blue">{{
                data ? data.account_recharge : 0
              }}</span>
                <span class="aggregateData">总充值：</span><span class="blue">{{ data ? data.order_money : 0 }}</span>
                <span class="aggregateData">总回收率：</span><span class="blue">{{ data ? data.tcba : 0 }}%</span>
                <!--          <strong class="aggregateData">总腾讯消耗：<span>{{}}</span></strong>-->
                <span class="aggregateData">增长率：</span><span class="blue">{{ data ? data.ir : 0 }}%</span> )</span>
              <div style="position: relative">
                <span style="margin-left: 10px">首付金额</span>
                <el-switch
                  v-model="value"
                  :width="40"
                  active-color="#409EFF"
                  inactive-color="rgb(191,191,191)"
                  style="margin-left: 10px"
                />
              </div>
            </div>
            <div class="table-label">
              <span>
                <img src="../../assets/images/13.小说/Wallet.webp">充值</span>
              <span>
                <img src="../../assets/images/13.小说/Financing.webp">单价</span>
              <span>
                <img src="../../assets/images/13.小说/Optional.webp">当日充值回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Trend.webp">累计充值回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card.webp">首冲回本</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card-two.webp">复充回本</span>
              <span>
                <img src="../../assets/images/13.小说/Group847.webp">首冲金额</span>
              <span>
                <img src="../../assets/images/13.小说/Currency.webp">复充金额
              </span>
            </div>
          </div>
        </div>
        <div>
          <el-table
            :data="newlist"
            border
            style="width: 100%"
            :cell-style="cellStyle"
            :header-cell-style="headerCellStyle"
            height="550"
          >
            <el-table-column
              fixed
              prop="date"
              align="center"
              :width="103"
            >
              <template slot="header">
                <div class="a-c">
                  <label>日期</label>
                  <i
                    slot="reference"
                    class="el-icon-s-comment rechargeButton"
                    @click="handleShowRechargeData"
                  />
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.date }}
              </template>
            </el-table-column>
            <el-table-column
              prop="order_money"
              label="累计充值"
              align="center"
              sortable
              :width="103"
            />
            <template v-if="showRechargeDataFlag">
              <el-table-column
                v-for="(item, idx) in newlist[0].specially_day_data || []"
                :key="idx"
                prop="order_money"
                :label="'充值' + '-' + rechargeDay[idx] + '天'"
                align="center"
                sortable
                :width="150"
              >
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.specially_day_data[idx].zc }}
                  </span>
                  <br>
                  <span>
                    {{ scope.row.specially_day_data[idx].tcbi }}
                  </span>
                </template>
              </el-table-column>
            </template>
            <el-table-column
              :key="itemKey"
              prop="account_recharge"
              label="成本"
              align="center"
              sortable
              :width="130"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.show">
                  <input
                    v-model="cost"
                    v-focus
                    class="costInput"
                    autofocus="autofocus"
                    :placeholder="scope.row.account_recharge"
                    @keydown.enter="handlCostKeyDown"
                    @blur="handlCostKeyDown"
                  >
                </span>
                <span
                  v-if="!scope.row.show"
                  @dblclick="reSetCost(scope.row)"
                >
                  {{ scope.row.account_recharge }}
                </span>
                <!-- <i
                  class="el-icon-edit editIcon"
                  @click="reSetCost(scope.row)"
                /> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="tcbi"
              label="回本率"
              align="center"
              :width="108"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.tcbi }}</div>
                <div>距今{{ scope.row.diff_today }}天</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="profitability"
              label="利润"
              align="center"
              :width="103"
            />
            <el-table-column
              v-for="(title, indx) in newlist.length > 0
                ? newlist[0].data
                : []"
              :key="indx + 8888"
              align="center"
              :label="'第' + (indx + 1) + '天'"
              :width="220"
            >
              <template slot-scope="scope">
                <div style="color: #f53f3f">
                  <img
                    src="../../assets/images/13.小说/Wallet.webp"
                    style="width: 16px"
                  >
                  {{ scope.row.data[indx].zc }}
                </div>
                <div class="powder">
                  <img
                    src="../../assets/images/13.小说/Optional.webp"
                    style="width: 16px"
                  >
                  {{ scope.row.data[indx].tcb }}
                  <el-divider direction="vertical" />
                  <img
                    src="../../assets/images/13.小说/Trend.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span>{{ scope.row.data[indx].tcbi ? scope.row.data[indx].tcbi : '0.00' }}</span>
                </div>
                <div class="powder">
                  <img
                    src="../../assets/images/13.小说/Bank-card.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="green">{{ scope.row.data[indx].scb }}</span>
                  <el-divider direction="vertical" />
                  <img
                    src="../../assets/images/13.小说/Bank-card-two.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="yellow">{{ scope.row.data[indx].fcb }}</span>
                </div>
                <div class="powder">
                  <img
                    src="../../assets/images/13.小说/Financing.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="blue">{{ scope.row.data[indx].cao }}</span>
                </div>
                <div v-show="value">
                  <img
                    src="../../assets/images/13.小说/Currency.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="green">{{ scope.row.data[indx].sc }}</span>
                  <el-divider direction="vertical" />
                  <img
                    src="../../assets/images/13.小说/Currency.webp"
                    style="width: 16px;margin-right:5px"
                  >
                  <span class="yellow">{{ scope.row.data[indx].fc }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination-right
          :total="newtotal"
          :page-sizes="[10]"
          @size-change="fetchPageSizer"
          @current-change="fetchCurrentPager"
        />
      </el-card>
      <!-- 图表容器 （示例4个） -->
      <div class="chart-layout">
        <div
          ref="chart1"
          class="chart-item"
        />
        <div
          ref="chart2"
          class="chart-item"
        />
        <div
          ref="chart3"
          class="chart-item"
        />
        <div
          ref="chart4"
          class="chart-item"
        />
        <div style="width: 100%;text-align: right;padding:0px 16px; border-radius:8px;background-color: #FFFFFF;position:relative">
          <el-select v-model="selectedDay" placeholder="请选择" style="position:absolute;top:16px;right:24px;z-index:999;width:124px" @change="selewchange">
            <el-option
              v-for="item in optionsr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <div
            ref="chart5"
            class="chart-item2"
          />
        </div>
      </div>
      <div style="padding-top: 16px;background-color: #F1F2F5">
        <el-card shadow="never">
          <div
            slot="header"
            class="clearfix header-box"
          >
            <span class="header-title">日成交分析</span>
            <div class="header-more-btn">查看详情</div>
          </div>

          <el-table
            class="daily-table"
            :data="dailyTransData"
            stripe
            @sort-change="handleDailySort"
          >
            <el-table-column
              prop="date"
              label="日期"
            />
            <el-table-column
              prop="order_money"
              label="订单金额"
            />
            <el-table-column
              prop="tcbi"
              label="累计充值回报率"
            />
            <el-table-column
              prop="fc"
              label="复充"
            />
            <el-table-column
              prop="sc"
              label="首充"
            />
            <el-table-column
              prop="zc"
              label="总充"
            />
            <el-table-column
              prop="cao"
              label="单价"
            />
            <el-table-column
              prop="fcb"
              label="复充回报率"
            />
            <el-table-column
              prop="scb"
              label="首充回报率"
            />
            <el-table-column
              prop="tcb"
              label="总充回报率"
            />
          </el-table>

          <div class="text-right mt-4">
            <pagination-right
              :total="dailyTotal"
              :page-sizes="[10]"
              style="margin-top: 20px"
              @size-change="fetchPageSizerrr"
              @current-change="fetchCurrentPagerrrr"
            />
          </div>
        </el-card>
      </div>
    </main>
  </div>
</template>

<script>
// import Pagination from '@/components/Pagination'
import PaginationRight from '@/components/PaginationRight'
import { getList, modifyCost } from '@/api/report/reportDay'
import { getSelectList } from '@/api/report/SelectData.js'
import { getFormData, newgetFormData } from '@/api/report/wechatUsers.js'
import * as echarts from 'echarts'
import CountTo from 'vue-count-to'

import dialogFocus from '@/layout/mixin/dialogFocus'
import { preditdayv2, preditdaygraphics, preditdaygraphicslist } from '@/api/releaseGroup.js'
import { getFictionList, commonreportoptions } from '@/api/copyReleaseGroup.js'
export default {
  name: 'ReportDay',
  components: {
    PaginationRight,
    CountTo
  },
  mixins: [dialogFocus],
  props: {
    displayType: {
      type: String,
      default: 'list'
    }
  },
  data() {
    return {
      data: null,
      datas: null,
      timeDefaultShow: '',
      total: 0,
      value: false,
      loading: false,
      searchForm: [],
      tableData: [],
      updateTime: null,
      data11: null,
      selectListData: [], // 筛选列表数据
      selectQueryData: {
        // 请求数据
        app_id: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1,
        start_date: null,
        end_date: null,
        launch_platform_type: ''
      },
      modifyCostQuery: {
        app_id: null,
        date: null,
        cost: null
      },
      rechargeDay: [3, 7, 15, 30, 45, 60], // 天数
      showRechargeDataFlag: false,
      visible: false,
      cost: null,
      index: -1,
      itemKey: 0,
      isDownloadAll: true, // 判断是否下载全部数据
      timesr: '',
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() > new Date().getTime() - (86400000 - 24 * 60 * 60 * 1000)
        }
      },
      chart: null,
      // 图表数据
      mockList: [],
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      dailyTransData: [], // 列表数据
      dailyTotal: 0, // 总条数
      dailyPageSize: 10, // 每页条数
      dailyCurrentPage: 1, // 当前页
      newlist: [],
      newtotal: null,
      newobj: null,
      chartData: {},
      selectedDay: 3, // 默认 3 天
      optionsr: [{
        value: 3,
        label: '3天'
      },
      {
        value: 7,
        label: '7天'
      },
      {
        value: 15,
        label: '15天'
      },
      {
        value: 30,
        label: '30天'
      },
      {
        value: 45,
        label: '45天'
      },
      {
        value: 60,
        label: '60天'
      }],
      predata: [],
      pretotal: null,
      optionstoufang: [],
      novel_name: null
    }
  },
  watch: {
    displayType(newVal, oldVal) {
      console.log('displayType changed from', oldVal, 'to', newVal)
      // 根据需要执行的逻辑
      // eslint-disable-next-line eqeqeq
      if (newVal == 'chart') {
        this.selectQueryData.page = 1
        this.newdata()
        this.daychartr()
        this.dailytransactions()
      } else {
        this.selectQueryData.page = 1
        this.getList()
      }
    }
  },
  created() {
    this.timeDefaultShow = new Date()
    this.timeDefaultShow.setMonth(new Date().getMonth() - 1)
    // this.getList()
    this.getSelectListData()
    this.oplistr()
  },
  mounted() {
    const self = this
    this.$nextTick(() => {
      document.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          self.handlCostKeyDown()
        }
      })
    })
    console.log('图标第一次渲染111')

    // this.fetchMockData()
  },
  methods: {
    // 获取筛选列表
    getSelectListData() {
      getSelectList().then(res => {
        this.selectListData = res
      })
    },
    // 修改成本
    postModifyCost() {
      modifyCost(this.modifyCostQuery).then(res => {
        this.getList()
      })
    },
    // 获取表格数据
    getList() {
      this.datas = []
      this.loading = true
      getList(this.selectQueryData).then(res => {
        if (res.data.list.length !== 0) {
          this.tableData = res.data.list
        }
        this.total = res.data.page_info.total
        this.updateTime = res.data.last_modify_time
        if (res.data.list.length !== 0) {
          this.data = this.tableData[0]
        }
        // 设置显示隐藏flag
        for (let i = 0; i < res.data.list.length; i++) {
          this.tableData[i].show = false
          this.tableData[i].select = i
        }
        this.loading = false
      })
    },
    fetchPageSize(e) {
      this.selectQueryData.page = e
      this.getList()
    },
    fetchCurrentPage(e) {
      this.selectQueryData.page = e
      this.getList()
    },
    fetchPageSizer(e) {
      this.selectQueryData.page = e
      this.newdata()
    },
    fetchCurrentPager(e) {
      this.selectQueryData.page = e
      this.newdata()
    },
    fetchPageSizerrr(e) {
      this.selectQueryData.page = e
      this.dailytransactions()
    },
    fetchCurrentPagerrrr(e) {
      this.selectQueryData.page = e
      this.dailytransactions()
    },
    // 搜索按钮
    handleSearch() {
      this.isDownloadAll = false
      this.selectQueryData.page = 1
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.$refs.pagination.select(1)
        this.getList()
      } else {
        this.newdata()
        this.daychartr()
        this.dailytransactions()
      }
    },
    // 重置按钮
    handleReset() {
      this.selectQueryData = {
        // 请求数据
        app_id: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1,
        start_date: null,
        end_date: null,
        launch_platform_type: ''
      }
      this.timesr = ''
      this.isDownloadAll = true
      this.novel_name = null
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newdata()
        this.daychartr()
        this.dailytransactions()
      }
    },
    // ondblclickCost(row) {
    //   console.log(123123132, row)
    //   this.$set(this.datas)
    //   this.index = -1
    //   for (let i = 0; i < this.datas.length; i++) {
    //     if (row[0].select === this.datas[i][0].select) {
    //       this.index = i
    //       this.datas[i][0].show = true
    //       return
    //     }
    //   }
    //   // this.datas[index][0].show = true
    //   console.log(row, this.index)
    // },
    postCostData() {
      if (this.cost === null) return
      if (!this.modifyCostQuery.app_id || !this.modifyCostQuery.date || !this.modifyCostQuery.cost) {
        this.$message({
          message: '请选择公众号再修改成本',
          type: 'error'
        })
        return
      } else {
        this.postModifyCost()
      }
    },
    // 修改成本回车确认
    handlCostKeyDown() {
      const i = this.index
      this.itemKey = Math.random()
      this.tableData[i].show = false
      this.modifyCostQuery.app_id = this.selectQueryData.app_id
      this.modifyCostQuery.date = this.tableData[i].date
      this.modifyCostQuery.cost = this.cost
      this.postCostData()
      this.cost = null
      this.index = -1
    },
    // 双击点击修改成本，单独修改table某项数据
    reSetCost(row) {
      for (let i = 0; i < this.tableData.length; i++) {
        // 挑出需要修改的那条数据
        if (row.select === this.tableData[i].select) {
          // 1. 把所有的input输入框隐藏
          this.tableData.forEach(item => {
            item.show = false
          })
          // 存放挑出来的那项数据的标识备用
          this.index = i
          // 2. 显示需要修改的那项数据的input输入框
          this.tableData[i].show = true
          // vue无法检测嵌套太深的对象数据的变化，实时试图更新因此失效，所以这里给修改项添加随机key用来强制更新视图
          this.itemKey = Math.random() * 10
          // 完成后跳出循环
          return
        }
      }
    },
    // switch功能函数
    doClearAction(data) {
      const action = {
        app: () => {
          this.selectQueryData.app_id = null
        },
        platform: () => {
          this.selectQueryData.platform_id = null
        },
        novel: () => {
          this.selectQueryData.novel_id = null
        },
        lead: () => {
          this.selectQueryData.lead_id = null
        },
        user: () => {
          this.selectQueryData.user_id = null
        }
      }
      return action[data]()
    },
    handleShowRechargeData() {
      if (!this.showRechargeDataFlag) {
        this.showRechargeDataFlag = true
      } else {
        this.showRechargeDataFlag = false
      }
    },
    downloadData(dataQuery = null, message = '') {
      getFormData(dataQuery)
        .then(res => {
          this.$message({
            message: `${message}下载成功，任务ID为：${res.data.task_id}`,
            type: 'success',
            time: '3000'
          })
        })
        .catch(err => {
          this.$message({
            message: `${message}下载失败：${err}`,
            type: 'error'
          })
        })
    },
    // 如果对象有一个属性不为空，则返回true
    filterSelectQueryData(data) {
      for (const item in data) {
        if (data[item] !== null) {
          return true
        }
      }
      return false
    },
    // 复制对象
    copyObjData(objData) {
      const downloadQueryData = {}
      for (const item in objData) {
        downloadQueryData[item] = this.selectQueryData[item]
      }
      return downloadQueryData
    },
    handleDownloadData() {
      if (this.isDownloadAll) {
        this.downloadData(null, '所有数据')
        return
      }
      const copyObjData = this.copyObjData(this.selectQueryData) // 复制对象
      delete copyObjData.page // 删除page属性,请求不需要携带page
      if (this.filterSelectQueryData(copyObjData)) {
        // 判断筛选值是否存在
        this.downloadData(copyObjData, '筛选数据')
      } else {
        this.downloadData(null, '所有数据')
      }
    },
    newhandleDownloadData() {
      if (this.isDownloadAll) {
        this.newdownloadData(null, '所有数据')
        return
      }
      const copyObjData = this.copyObjData(this.selectQueryData) // 复制对象
      delete copyObjData.page // 删除page属性,请求不需要携带page
      if (this.filterSelectQueryData(copyObjData)) {
        // 判断筛选值是否存在
        this.newdownloadData(copyObjData, '筛选数据')
      } else {
        this.newdownloadData(null, '所有数据')
      }
    },
    newdownloadData(dataQuery = null, message = '') {
      newgetFormData(dataQuery)
        .then(res => {
          this.$message({
            message: `${message}下载成功，任务ID为：${res.data.task_id}`,
            type: 'success',
            time: '3000'
          })
        })
        .catch(err => {
          this.$message({
            message: `${message}下载失败：${err}`,
            type: 'error'
          })
        })
    },
    getData(date) {
      console.log(date)
      this.selectQueryData.start_date = date[0]
      this.selectQueryData.end_date = date[1]
    },
    // 下载按钮
    // handleDownload({ clientX, clientY }) {
    //   this.$emit('download', {
    //     x: clientX,
    //     y: clientY
    //   }, this.selectQueryData)
    // }this.fetchMockData()
    rand(min, max) {
      // 小工具：闭区间随机整数
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    fetchMockData() {
      const days = 7
      const tmp = []

      for (let i = 0; i < days; i++) {
        const dateStr = this.getDateOffset(i)

        const rechargeVal = this.rand(100, 1500)
        const costVal = this.rand(50, 800)
        const profitVal = rechargeVal - costVal
        const rateVal = +(costVal ? (profitVal / costVal) * 100 : 0).toFixed(2)

        tmp.push({
          date: dateStr,
          recharge: rechargeVal,
          cost: costVal,
          profit: profitVal,
          rate: rateVal,
          /* 下面 6 个用于柱状图 */
          day3: this.rand(100, 1500),
          day7: this.rand(100, 1500),
          day15: this.rand(100, 1500),
          day30: this.rand(100, 1500),
          day45: this.rand(100, 1500),
          day60: this.rand(100, 1500)
        })
      }

      this.mockList = tmp
      this.$nextTick(() => this.renderAllCharts())
    },

    /**
     * 2. 根据 offset 生成日期字符串 (如 "2023-04-08")
     */
    getDateOffset(offset) {
      const d = new Date()
      d.setDate(d.getDate() - offset) // 向前推 offset 天
      const y = d.getFullYear()
      let m = d.getMonth() + 1
      let day = d.getDate()
      if (m < 10) m = '0' + m
      if (day < 10) day = '0' + day
      return `${y}-${m}-${day}`
    },

    /**
     * 3. 初始化并渲染 4 个图表
     */
    renderAllCharts() {
      // 渲染前先销毁，防止重复初始化
      console.log('chart1 ref:', this.$refs.chart1)
      this.disposeAllCharts()
      console.log('chart1 ref:', this.$refs.chart1)

      // 图1: 每日充值
      this.chart1 = echarts.init(this.$refs.chart1)
      this.chart1.setOption(this.getRechargeOption())

      // 图2: 每日成本
      this.chart2 = echarts.init(this.$refs.chart2)
      this.chart2.setOption(this.getCostOption())

      // 图3: 每日利润
      this.chart3 = echarts.init(this.$refs.chart3)
      this.chart3.setOption(this.getProfitOption())

      // 图4: 回本率
      this.chart4 = echarts.init(this.$refs.chart4)
      this.chart4.setOption(this.getRateOption())

      if (this.$refs.chart5) {
        this.chart5 = echarts.init(this.$refs.chart5)
        this.chart5.setOption(this.getRechargeBarOption())
      }
      // 监听窗口大小变化，自适应
      window.addEventListener('resize', this.handleResize)
    },
    disposeAllCharts() {
      if (this.chart1) {
        this.chart1.dispose()
        this.chart1 = null
      }
      if (this.chart2) {
        this.chart2.dispose()
        this.chart2 = null
      }
      if (this.chart3) {
        this.chart3.dispose()
        this.chart3 = null
      }
      if (this.chart4) {
        this.chart4.dispose()
        this.chart4 = null
      }
      if (this.chart5) {
        this.chart5.dispose()
        this.chart5 = null
      }
      window.removeEventListener('resize', this.handleResize)
    },
    handleResize() {
      this.chart1 && this.chart1.resize()
      this.chart2 && this.chart2.resize()
      this.chart3 && this.chart3.resize()
      this.chart4 && this.chart4.resize()
      this.chart5 && this.chart5.resize()
    },

    /**
     * 1. 累积充值 (使用 #008DFF)
     */
    getRechargeOption() {
      const xData = this.mockList.map(item => item.date)
      const yData = this.mockList.map(item => item.recharge)
      return {
        title: { text: '累计充值（元 ）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '充值',
            type: 'line',
            smooth: false, // 平滑曲线
            symbol: 'circle', // 拐点形状
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF' // 主色
            },
            itemStyle: {
              color: '#008DFF', // 拐点颜色
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              // 区域渐变 (顶部不透明, 底部透明)
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}元'
            }
          }
        ]
      }
    },

    getCostOption() {
      const xData = this.mockList.map(item => item.date)
      const yData = this.mockList.map(item => item.cost)
      return {
        title: { text: '成本（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '成本',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}元'
            }
          }
        ]
      }
    },

    /**
     * 3. 每日利润 (使用 #5FE1E0)
     */
    getProfitOption() {
      const xData = this.mockList.map(item => item.date)
      const yData = this.mockList.map(item => item.profit)
      return {
        title: { text: '利润（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '利润',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}元'
            }
          }
        ]
      }
    },

    /**
     * 4. 回本率 (使用 #008DFF)
     */
    getRateOption() {
      const xData = this.mockList.map(item => item.date)
      const yData = this.mockList.map(item => item.rate)
      return {
        title: { text: '回本率（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          },
          axisLabel: {
            formatter: '{value}%'
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}%'
            }
          }
        ]
      }
    },
    /**
     * 5. 表格 (使用 #008DFF)
     */

    getRechargeBarOption() {
      const xData = this.mockList.map(i => i.date).reverse()
      const arr = k => this.mockList.map(i => i[k]).reverse()
      console.log('xData', xData)
      console.log('arr', arr)
      const g = hex =>
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: hex },
          { offset: 1, color: hex + '40' }
        ])

      return {
        title: { text: '累计充值天数（万）' },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }},
        legend: {
          bottom: 0,
          data: ['3天', '7天', '15天', '30天', '45天', '60天']
        },
        grid: { left: 40, right: 20, top: 40, bottom: 50 },

        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { type: 'dashed', color: '#E0E0E0' }},
          axisLine: { show: false },
          axisTick: { show: false }
        },

        series: [
          {
            name: '3天',
            type: 'bar',
            barWidth: 16,
            data: arr('day3'),
            itemStyle: { color: g('#008DFF') }
          },
          {
            name: '7天',
            type: 'bar',
            barWidth: 16,
            data: arr('day7'),
            itemStyle: { color: g('#5FE1E0') }
          },
          {
            name: '15天',
            type: 'bar',
            barWidth: 16,
            data: arr('day15'),
            itemStyle: { color: g('#FFC800') }
          },
          {
            name: '30天',
            type: 'bar',
            barWidth: 16,
            data: arr('day30'),
            itemStyle: { color: g('#537FF1') }
          }
        ]
      }
    },
    handleDailySort() {},
    fmtCurrency() {},
    fmtPercent() {},
    onDailySizeChange() {},
    onDailyPageChange() {},
    // 获取日报表列表数据go
    newdata() {
      preditdayv2(this.selectQueryData).then((res) => {
        console.log('res', res)
        this.newlist = res.data.list
        this.newtotal = res.data.count
        if (res.data.list.length !== 0) {
          this.newobj = res.data.list[0]
        }
      })
    },
    // 获取日报表图形数据
    daychartr() {
      preditdaygraphics(this.selectQueryData).then((res) => {
        console.log('图形报表res', res.data.data)
        this.chartData = res.data.data // 存所有数据
        // this.fetchMockData()
        this.disposeAllCharts()
        // 图1: 每日充值
        this.chart1 = echarts.init(this.$refs.chart1)
        this.chart1.setOption(this.getRechargeOptionr(res.data.data.total_cumulative_recharge))
        // 图2: 每日成本
        this.chart2 = echarts.init(this.$refs.chart2)
        this.chart2.setOption(this.getCostOptionuser(res.data.data.account_recharge))
        // 图3: 每日利润
        this.chart3 = echarts.init(this.$refs.chart3)
        this.chart3.setOption(this.getProfitOptionr(res.data.data.profitability))
        // 图4: 回本率
        this.chart4 = echarts.init(this.$refs.chart4)
        this.chart4.setOption(this.getRateOptionrlu(res.data.data.rate_of_return))

        this.chart5 = echarts.init(this.$refs.chart5)
        this.chart5.setOption(this.getRechargeAndRecoveryOption(res.data.data, this.selectedDay))
      })
    },

    getRechargeOptionr(total_cumulative_recharge) {
      const xData = total_cumulative_recharge.map(item => item.name)
      const yData = total_cumulative_recharge.map(item => Number(item.value)) // 转为数字

      return {
        title: { text: '累计充值（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#4e5969' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '充值',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getCostOptionuser(account_recharge) {
      const xData = account_recharge.map(item => item.name)
      const yData = account_recharge.map(item => Number(item.value)) // 转为数字

      return {
        title: { text: '成本（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#4e5969' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '成本',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getProfitOptionr(profitability) {
      const xData = profitability.map(item => item.name)
      const yData = profitability.map(item => Number(item.value)) // 字符串转数字

      return {
        title: { text: '利润（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#4e5969' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '利润',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元',
              show: false
            }
          }
        ]
      }
    },
    getRateOptionrlu(rate_of_return) {
      const xData = rate_of_return.map(item => item.name)
      const yData = rate_of_return.map(item => parseFloat(item.value)) // 字符串转为数字

      return {
        title: { text: '回本率（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#4e5969' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}%' // 标签加上百分号
              show: false
            }
          }
        ]
      }
    },
    getRechargeAndRecoveryOption(data, day = 60) {
      const rechargeKey = `cumulative_recharge_${day}`
      const recoveryKey = `recovery_rate_${day}`

      const rechargeArr = data[rechargeKey] || []
      const recoveryArr = data[recoveryKey] || []

      const nameList = rechargeArr.map(item => item.name)

      const rechargeMap = new Map()
      rechargeArr.forEach(item => {
        rechargeMap.set(item.name, parseFloat(item.value))
      })

      const recoveryMap = new Map()
      recoveryArr.forEach(item => {
        recoveryMap.set(item.name, parseFloat(item.value))
      })

      return {
        title: {
          text: `累计充值与回收（${day}天）`,
          left: 0, // 标题靠右
          top: 0,
          textStyle: {
            color: 'rgba(29, 33, 41, 1)',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          // 固定到右上角，跟标题挨着
          position: function(point, params, dom, rect, size) {
            return [size.viewSize[0] - size.contentSize[0] - 10, 10]
          },
          formatter(params) {
            const recharge = params.find(p => p.seriesName === '充值金额')
            const recovery = params.find(p => p.seriesName === '回收率')
            return `${params[0].name}<br/>
                    充值金额: ${recharge?.value} 元<br/>
                    回收率: ${recovery?.value} %`
          }
        },
        legend: {
          bottom: 0,
          data: ['充值金额', '回收率'],
          textStyle: { color: '#4e5969' }
        },
        grid: { left: '3%', right: '4%', bottom: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: nameList,
          axisLabel: { color: '#4e5969' }
        },
        yAxis: {
          type: 'value',
          name: '金额（元）',
          axisLabel: {
            color: '#ccc',
            formatter: '{value}'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#ccc'
            }
          }
        },
        series: [
          {
            name: '充值金额',
            type: 'bar',
            data: nameList.map(name => rechargeMap.get(name) || 0),
            itemStyle: {
              barBorderRadius: [7, 7, 0, 0],
              borderRadius: [7, 7, 0, 0],
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: '#008DFF' },
                  { offset: 1, color: 'rgba(0,141,255,0.5)' }
                ]
              }
            }
          },
          {
            name: '回收率',
            type: 'bar',
            data: nameList.map(name => recoveryMap.get(name) || 0),
            itemStyle: {
              barBorderRadius: [7, 7, 0, 0],
              borderRadius: [7, 7, 0, 0],
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: '#5FE1E0' },
                  { offset: 1, color: 'rgba(95,225,224,0.5)' }
                ]
              }
            }
          }
        ]
      }
    },
    selewchange() {
      this.daychartr()
    },
    dailytransactions() {
      preditdaygraphicslist(this.selectQueryData).then((res) => {
        console.log('日交易分析', res.data.list)
        this.dailyTransData = res.data.list
        this.dailyTotal = res.data.count
      })
    },
    allday() {
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newdata()
        this.daychartr()
        this.dailytransactions()
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 根据列名判断颜色
      if (column.property === 'date' || column.property === 'order_money' || column.property === 'account_recharge' || column.property === 'tcbi' || column.property === 'profitability') {
        return { background: '#F5F7FB' } // 橙色
      }
      return {}
    },
    headerCellStyle({ column, columnIndex }) {
      if (
        column.property === 'date' ||
        column.property === 'order_money' ||
        column.property === 'account_recharge' ||
        column.property === 'tcbi' ||
        column.property === 'profitability' ||
        columnIndex === 0
      ) {
        return { backgroundColor: '#F5F7FB' }
      }
      return { backgroundColor: '#F5F7FB' }
    },
    async querySearchAsync(queryString, cb) {
      const data = await getFictionList({ name: queryString || null })
      const newss = data.data.list.map((item) => {
        return {
          value: `${item.name} (${item.platform})`,
          address: item.id
        }
      })
      cb(newss)
    },
    handleSelect(item) {
      this.selectQueryData.novel_id = item.address
    },
    async oplistr() {
      const res = await commonreportoptions()
      this.optionstoufang = res.data.launch_platform_type
    }
  }
}
</script>

<style scoped lang="less">
.el-card {
  margin-bottom: 16px;
  position: relative;

  .btn-setbox {
    position: absolute;
    right: 20px;
    bottom: 28px;
  }
}
.indexReport {
  min-width: 1200px;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    label {
      padding: 5px 10px;
      border: 1px solid #eee;
      background: #fff;
    }
  }

  main {
    color: #1d2129;
    background: #fff;
    margin-top: 0px;
    .form-top {
      display: flex;
      justify-content: space-between;
      div {
        img {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }
      }
      .table-label {
        span {
          color: #86909c;
          margin-left: 10px;
        }
      }
    }
    .form {
      padding: 20px;
      background: #fff;
      border: 1px solid #eee;
      border-bottom: none;
      .switch {
        color: #fff;
        position: absolute;
        top: 2px;
        left: 7px;
      }
      .aggregateData {
        margin-left: 20px;
      }
      .blue {
        color: #9D2631;
        font-weight:bold;
      }
    }
    .table {
      .el-icon-s-comment {
        float: right;
        line-height: 2;
      }
    }
    .magRig {
      margin-right: 10px;
    }
    .magLfte {
      margin-left: 10px;
    }
    .rechargeButton {
      padding-right: 5px;
      cursor: pointer;
    }
    .costInput {
      border: 1px solid #ccc;
      width: 100px;
      height: 30px;
    }
    .editIcon {
      cursor: pointer;
    }
  }
}
.powder {
  color: #000;
}
.el-table .cell div {
  margin: 5px 0px;
}
.el-table .el-divider {
  margin: 0px 5px !important;
}
.indexReport .title div {
  display: flex;
  align-items: center;
}
.el-card__body {
  .total-cell {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right:1px solid rgba(231, 231, 231, 1);
    .total-img {
      img {
        width: 56px;
        height: 56px;
      }
    }
    .total-data {
      padding-top:3px;
      font-size: 18px;
      color: #1d2129;
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-left: 10px;
      box-sizing:border-box;
      justify-content: space-between;

      div:nth-of-type(1) {
        font-size: 16px;
        color: #4e5969;
      }
      div:nth-of-type(2) {
        font-weight: bold;
      }
      span {
        font-size: 16px;
      }
    }
  }
  .total-cell:last-of-type{
    border-right:none;
  }
}
.report-demo {
  padding: 20px;
}
.chart-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 上下左右间距统一 */
  background-color: #f1f2f5;
}
.chart-box {
  width: 48%;
  height: 300px;
  border: 1px solid #eee;
  position: relative;
}
.chart-item {
  flex: 1 1 calc(50% - 16px); /* 每行两个，减去gap */
  height: 426px;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box; /* 避免padding影响宽度计算 */
}
.chart-item2 {
  flex: 1 1 calc(50% - 16px); /* 每行两个，减去gap */
  height: 426px;
  padding: 20px 0;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box; /* 避免padding影响宽度计算 */
  display: flex;           /* 开启flex布局 */
  align-items: center;     /* 垂直居中 */
  justify-content: center; /* 水平居中（可选，如果也要居中） */
}
/* 让 table 自动平分列宽 */
.daily-table .el-table__header-wrapper table,
.daily-table .el-table__body-wrapper table {
  table-layout: fixed;
  width: 100%;
}

///* 隐藏所有竖线（单元格右侧的默认边框） */
//.daily-table .el-table__header-wrapper th,
//.daily-table .el-table__body-wrapper td {
//  border-right: red 1px solid !important;
//}

/* 只保留行底部横线 */
.daily-table .el-table__body-wrapper tr {
  border-bottom: 1px solid #ebeef5; /* 根据设计稿调整颜色 */
}

/* 也给表头加一条横线，分隔标题和内容 */
.daily-table .el-table__header-wrapper tr {
  border-bottom: 1px solid #ebeef5;
}
.chart-item:last-of-type {
  width: 100% !important;
}
.header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 表头背景色 & 居中 */
.daily-table ::v-deep .el-table__header-wrapper th {
  background-color: #f5f7fa !important;
  text-align: center !important;
}

/* 表格内容居中 */
.daily-table ::v-deep .el-table__body-wrapper td {
  text-align: center !important;
}
.header-title {
  font-size: 18px;
  font-weight: bold;
}
.header-more-btn {
  font-size: 14px;
  color: #86909c;
  position: absolute;
  right: 20px;
}
/deep/ .el-table--border td,
/deep/ .el-table--border th {
  border-right: 1px solid #dfe6ec !important;
}
.a-c{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  i{
    margin-left:5px;
  }
}

</style>
